import client from "./client";

export default {
    async getPropertyTypologies(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/property-types', filters)));
    },

    async createPropertyTypologies(data) {
        return client.parseResponse(await client.post('/property-types', data))
    },

    async getPropertyTypology(id) {
        return client.parseResponse(await client.get('/property-types/' + id));
    },

    async editPropertyTypology(data) {
        return client.parseResponse(await client.put('/property-types/' + data.id, data))
    },

    async deletePropertyTypology(data) {
        return client.parseResponse(await client.delete('/property-types/' + data.id, data))
    }
}
